import { Alert, Gap, ISelectMultiOption } from '@salecycle/ui-component-library';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import BlocklistAllowlistForm from './BlocklistAllowlistForm';
import BlocklistAllowlistTable from './BlocklistAllowlistTable';
import { IBlocklistAllowlistItem, recordTypeEmail } from '../entities/blocklist-allowlist-constants';
import styled from 'styled-components';
import React from 'react';

interface IDataDisplayProps {
  dataToDisplay: IBlocklistAllowlistItem[];
  addBlocklistAllowlistCallback: (newItem: IBlocklistAllowlistItem[]) => void;
  addItemValueToSelectMulti: (inputValue: string) => void;
  deleteBlocklistAllowlistCallback: (itemKey: string, listType: string, recordType: string) => void;
  isLoading: boolean;
  itemName: string;
  itemNameChangeHandler: (value: string) => void;
  itemValue: ISelectMultiOption<string>[];
  invalidItemValues: Map<string, string[]>;
  duplicateItemValues: string[];
  setInvalidItemValues: (value: Map<string, string[]>) => void;
  setDuplicateItemValues: (value: string[]) => void;
  itemValueChangeHandler: (value: ISelectMultiOption<string>[]) => void;
  listType: string;
  valueType: string;
  setItemName: (value: string) => void;
  setItemValue: (value: ISelectMultiOption<string>[]) => void;
}

export type Props = IDataDisplayProps;

const SpaceBetweenTabs = styled.div`
  padding: ${({ theme }) => theme.designToken.spacing4};
`;

export const BlocklistAllowlistDataDisplay: FC<IDataDisplayProps> = (props: IDataDisplayProps) => {
  const { t } = useTranslation();

  const [pageNumberEmail, setPageNumberEmail] = React.useState(0);
  const [pageNumberPhone, setPageNumberPhone] = React.useState(0);

  return (
    <div data-test-id="BlocklistAllowlistDataDisplay">
      <SpaceBetweenTabs />
      {props.dataToDisplay && props.dataToDisplay.length === 0 && (
        <>
          <Alert variation="info" heading={t(`settings.${props.listType}.${props.valueType}InfoAlert`)}></Alert>
          <Gap bottom={30} />
        </>
      )}
      <BlocklistAllowlistForm
        addBlocklistAllowlistCallback={props.addBlocklistAllowlistCallback}
        addItemValueToSelectMulti={props.addItemValueToSelectMulti}
        itemName={props.itemName}
        itemNameChangeHandler={props.itemNameChangeHandler}
        itemValue={props.itemValue}
        invalidItemValues={props.invalidItemValues}
        duplicateItemValues={props.duplicateItemValues}
        setInvalidItemValues={props.setInvalidItemValues}
        setDuplicateItemValues={props.setDuplicateItemValues}
        itemValueChangeHandler={props.itemValueChangeHandler}
        listType={props.listType}
        valueType={props.valueType}
        setItemName={props.setItemName}
        setItemValue={props.setItemValue}
      />
      {props.valueType === recordTypeEmail ? (
        <BlocklistAllowlistTable
          deleteBlocklistAllowlistCallback={props.deleteBlocklistAllowlistCallback}
          listData={props.dataToDisplay}
          isLoading={props.isLoading}
          listType={props.listType}
          valueType={props.valueType}
          pageNumber={pageNumberEmail}
          setPageNumber={setPageNumberEmail}
        />
      ) : (
        <BlocklistAllowlistTable
          deleteBlocklistAllowlistCallback={props.deleteBlocklistAllowlistCallback}
          listData={props.dataToDisplay}
          isLoading={props.isLoading}
          listType={props.listType}
          valueType={props.valueType}
          pageNumber={pageNumberPhone}
          setPageNumber={setPageNumberPhone}
        />
      )}
    </div>
  );
};
export default BlocklistAllowlistDataDisplay;
